import React from 'react'
import { AddKeyValue } from '../AddKeyValue'

export const Params = () => {
  return (
    <div>
      <AddKeyValue field="params" title="Add Params" />
    </div>
  )
}
